module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACHEL")]), _vm._v(" hurried down the city street the following Monday morning, anxious not to be late for work. She’d caught a slightly later train than usual, courtesy of the longer time it had taken her to get ready for work that morning. Now she was trying to make up for lost time, her sensibly shod feet working hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning a corner into a city street which faced east, Rachel was suddenly confronted by the rays of the rising sun slanting straight into her eyes. But she didn’t slacken her pace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The day was going to be warm again, she quickly realised. Too warm, really, for a black suit with a long-sleeved jacket. Spring had been late coming to Sydney this year, but it was now here with a vengeance. October had had record temperatures so far and today looked like no exception. Not a cloud marred the clear blue sky, making the weather forecast for a southerly change today highly unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no doubt about it. She’d have to buy some new work clothes soon. What she’d been wearing would not take her right through the spring till summer. She should never have been stupid enough to buy all long-sleeved suits to begin with. She’d buy something other than black next time too, though nothing bright or frivolous. Something which would go with black accessories. Light grey, perhaps. Or camel. That colour was very in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Unfortunately, such shopping would have to wait till ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Isabel got home from her honeymoon in three weeks’ time. Rachel didn’t have a clue where the shops were that Isabel had taken her to last time, and which catered brilliantly for the serious career girl. Admittedly, a large percentage of the clothes in those shops was black, but they also had other colours.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Till then, however, she was stuck with black. And long sleeves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thank heaven for air-conditioning, she thought as she pushed the sleeves up her arms and puffed her way up the increasingly steep incline.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sideways glance at her reflection in a shop window brought a groan to her lips. Her hair was still red, despite several washings yesterday and a couple more this morning. Maybe not quite as bright a red as it had been for the wedding on Saturday, but bright enough. She wished now she’d gone out yesterday and bought a brown hair dye. But at the time she’d been hoping the colour would still wash out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If Isabel hadn’t already been winging her way overseas on her honeymoon, Rachel would have torn strips off her mischief-making best friend. That hairdresser of hers must have used a semi-permanent colour on her hair, Rachel was sure of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Admittedly, she’d ended up looking pretty good for the wedding. From a distance. Amazing what a glamorous dress, a big hairdo and a make-up expert could achieve. But that was then and this was now, and bright red hair did not sit well with Rachel’s normally unmade-up face, or her decidedly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("un")]), _vm._v("-glamorous work wardrobe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("She was thankful that the repeated washings yesterday had toned down the colour somewhat. Hopefully, the way she was wearing it today—scraped back even ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("more severely than usual—would also minimise the effect. She would hate for Justin to think that she was suddenly trying to attract his attention in any way.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she’d told Isabel the other night, she liked her job. And she didn’t want to lose it. Or even remotely risk the good relationship she’d already established with her boss, which was very professional and based on mutual respect. Justin had told her only last week what a relief it was to come into work and not be overpowered by some cloying perfume, or confronted with a cleavage deep enough to lose the Harbour Bridge in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel was out of breath by the time she reached the tall city office block which housed the huge insurance company where she worked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she’d first heard about the job as Justin’s PA Rachel had been under the impression that Justin was an AWI executive. That wasn’t the case, however. He was an independent hot-shot financial analyst under contract to AWI to give them his exclusive financial advice for two years, after which Justin planned on starting up his own consultancy company. Preferably in an office away from the inner-city area, he’d explained to her one day over a mutual coffee break, ideally overlooking one of the northern beaches.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meanwhile, AWI had given him use of a suite of rooms on the fifteenth floor of their building, which was high up enough to have a good view of the city and the harbour.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("But the view wasn’t the only good thing about this suite of rooms. The space was incredible. Rachel had sole occupancy of the entire reception area, which was huge, and boasted its own powder room and tea-cum-store room, along with a massive semicircular work ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("station where three secretaries could have happily worked side by side without being cramped.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Justin’s office beyond was just as spacious, as well as having two large adjoining rooms, one furnished for meetings, the other for relaxing and entertaining. Rachel had never seen a better-stocked bar, not to mention such a lavish bathroom, tiled from top to bottom in black marble, with the most exquisite gold fittings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Justin had confided to her during her first interview that this suite of rooms had previously been occupied by an AWI superannuation-fund manager who’d redecorated as if he owned the company, and been subsequently sacked. No expense had been spared, from the plush sable carpet to the sleekly modern beech office furniture, the Italian cream leather sofas and the impressionistic art originals on the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearly, Justin being allotted this five-star suite of rooms showed how much his skills were valued by his temporary employers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel valued him as her boss, too. She admired his strong work ethics and his lack of personal arrogance. Most men with his looks and intelligence possessed egos to match. Justin didn’t. Not that he was perfect, by any means. He did have his difficult and demanding moments. And some days his mood left a lot to be desired.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, Rachel already knew she’d like nothing better than to go with him when he left to set up his own company. He’d already implied she could, if she wanted to. He seemed as pleased with her as she was with him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("A shaft of sunshine lit up Rachel’s red hair again as she pushed her way into the building’s foyer through the revolving glass doors. The top of her head fairly ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("glowed in the glass and she groaned again. She would definitely be going out at lunch time and buying that brown dye. Meanwhile, she would explain to Justin the reason behind her change of hair colour, and that it was as good as gone. Then he couldn’t jump to any wrong conclusions.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one gave Rachel a second glance during the lift ride up to the fifteenth floor, which was because none of the smartly dressed men and women in the lift even knew her. Few people who worked in the building knew her. Justin worked alone, with only the occasional fund manager actually dropping in for advice, face to face. Mostly they contacted Justin by phone or email, and vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So far, he hadn’t held a single meeting around the boardroom-like table in his meeting room, and only once to her knowledge had he entertained an AWI executive in the other room. Sometimes, he had a nap in there on one of the two sofas after he’d been working all night. He did attend monthly meetings upstairs with all the fund managers, but he never attended the company’s social functions, and he resolutely refused to become involved in AWI’s internal politics.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The truth was her boss was a loner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which suited Rachel just fine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She’d found that since her lengthy stay-at-home absence from the workforce—and the outside world in general—she’d become a bit agoraphobic. She liked the insular security of her present office situation, plus the little contact with strangers which her working day held. She no longer seemed to have the confidence she’d once had to make small talk with lots of people. She’d actually become quite shy, except with her very ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("close friends, like Isabel and Rafe, which wasn’t like her at all. She’d once had a very outgoing personality.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabel kept saying she’d get back to her old self eventually.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Rachel was beginning to doubt it. Her experiences over the last few years had definitely changed her. She’d become introverted. And serious. And, yes, plain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was one of the biggest changes in her, of course. She’d lost her looks. And dying her hair red wasn’t going to get them back. All it made her feel was foolish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lift doors opened and Rachel bolted down the corridor, hopeful of still arriving before Justin. He worked out in the company gym every day before work, and occasionally lost track of time. Hence his tardy arrival at the office on the odd morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door from the corridor was still locked, heralding that this was one of those mornings. Rachel sighed with relief as she found her key, already planning in her mind to be sitting at her desk, looking coolly composed and beavering away on her computer when Justin finally came in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was doing just that when the door burst open fifteen minutes later. Her heart did jump, but not for any sexually charged reason, as Isabel had fantasised the other night, just instant agitation. What would her boss say when he saw her hair?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Justin strode in, looking his usual attractive but conservative self in a navy pinstriped suit, white shirt and bland blue tie. His damp dark hair was slicked back at the sides, indicating that he’d not long showered. He had the morning papers tucked under one arm and was carrying his black briefcase in the other. He was frown")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("ing, though not at her, his deeply set blue eyes quite distracted, his thick dark brows drawn together over his strong, straight nose in an attitude of worried concentration.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Morning, Rachel,’ he said with only the briefest sidewards glance as he hurried past. ‘Hold the coffee for ten minutes, would you?’ he tossed over his shoulder as he forged on into his private sanctuary. ‘I have something I have to do first.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he banged the door shut behind him Rachel glared after him, her hazel eyes showing some feminine pique for once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well!’ she huffed at the closed door. ‘And good morning to you, too!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So much for his having noticed her red hair. It came to Rachel that she could have been sitting there stark naked this morning, and Justin would not have noticed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that her being naked was anything to write home about these days. Despite having put on a couple of pounds during the past month, she was still thin, her once noteworthy breasts having long ago shrunk from a voluptuous D-cup to a very average B plus. She’d complained about it to Isabel on Saturday when they were getting dressed before the wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You still have bigger boobs than me,’ Isabel returned as she surveyed Rachel in her underwear. ‘OK, so you’re thin, but you’re in proportion. Actually, you look darned good in the buff, girl. You’ve surprised me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel had laughed at the time. She laughed now, but with a different type of self-mockery. What on earth was she doing, even thinking about what she looked like naked? Who cared? No one was going to see her that way, except herself.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again, it was all Isabel’s fault, putting silly thoughts into her head about Justin and sex.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sex! Now, that was a subject not worth thinking about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So why was she suddenly thinking about it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel filled in the next eight minutes trying to work through her irritability, before giving up and rising to go pour Justin a mug of coffee from the coffee maker, which she kept perking all day. Justin liked his coffee. She figured that ten minutes would have passed by the time she carried it in to him. Any further delay was unacceptable. The sooner he noticed her red hair, and the sooner she explained the reason behind it, the sooner she’d be able to settle down to work, and put aside the fear of looking ludicrous in her boss’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Come in,’ Justin snapped when she tapped on his office door exactly ten minutes after his order.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She entered to find him sitting at the bank of computers which lined the far side of his U-shaped work station. His back remained to her as he rode his swivel chair down the long line of computers, peering at each screen for a couple of seconds as he went. His jacket was off and his shirtsleeves rolled up. His tie, she knew without being able to see it, would be loosened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Rachel made her way across the room Justin slid down in front of the furthest computer on the right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just put it down here,’ he directed, patting an empty spot next to his right elbow without looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grimacing with frustration, Rachel put the coffee down where ordered and was about to leave when she stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Justin…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mmm?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He still didn’t look up.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sighed. ‘Justin, I need to talk to you,’ she said firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What about?’ Again, no eye contact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wanted to explain to you about my red hair.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What red hair?’ He spun round from the computer, his eyes finally lifting. He frowned up at her, his head tipping slightly to one side. ‘Mmm. It’s a bit bright for you, isn’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel winced. ‘It looked all right for the wedding on Saturday,’ she said, her pride demanding she say something in her own defence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His blue eyes widened. ‘Wedding? What wedding? My God, Rachel, you didn’t go and get married on the weekend without telling me, did you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel almost laughed. As if.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t think you need worry about that ever happening, Justin,’ she said drily. ‘No, I was a bridesmaid at my best friend’s wedding on Saturday and she insisted on having my hair dyed red for the day. It was supposed to wash out afterwards but, as you can see, it didn’t. I just wanted to reassure you that I’m going to dye it back to brown tonight.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged his indifference, then picked up his coffee. ‘Why bother?’ he said between sips. ‘It doesn’t look "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" bad. And it’ll wash out—or grow out—eventually.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel’s shoulders stiffened. It would take two years for it to grow out. Did he honestly think she had such little personal pride that she’d walk around with half-red, half-brown hair for two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("years")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearly, he did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It looks dreadful and you know it,’ she said sharply, and whirled away from him before she did something she would regret.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel could feel him staring after her as she marched towards the open doorway, probably wondering what was wrong with her. She’d never spoken to him in that tone before. But when she turned to close the door behind her he wasn’t staring after her at all. Or even thinking about her. He was back, peering at the maze of figures on the computer, her red hair—plus her slight outburst—clearly forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel didn’t realise the extent of her anger till she tried to get back to work. Why she was so angry with Justin, she couldn’t understand. His indifferent reaction to her hair should have made her happy. It was all rather confusing. But there’d been a moment in there—a vivid, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("violent")]), _vm._v(" moment—when she’d wanted to snatch the coffee out of his hands and throw it in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was perhaps just as well that her boss didn’t emerge for the rest of the morning, or call her for more coffee to be delivered. Clearly, he was steeped in something important, some sudden programming brainwave or financial crisis which required his undivided attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the month she’d been his PA, Rachel had discovered that Justin was a computer genius as well as a financial one, and had created several programs for following and predicting stock-market trends, as well as analysing other economical forces. Aside from her general secretarial duties, Rachel spent a couple of hours each day entering and downloading data into the extensive files these programs used. They needed constant updating to work properly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was completing that daily and slightly tedious area of her job shortly before noon, when the main door from the corridor opened and Justin’s mother walked in.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alice McCarthy was in her early sixties, a widow with two sons. She’d been one of Rachel’s best customers during the four years she’d made ends meet by using her sewing skills at home. A tall, broad-shouldered woman with a battleship bust and surprisingly slender hips, Alice had difficulty finding clothing to fit off the peg. But she loved shopping for clothes, rather than having them made from scratch, and had more than enough money to indulge her passion. Mr McCarthy had been a very successful stockbroker in his day, and, according to Alice, a bit of a scrooge, whereas Alice veered towards the other extreme. Consequently, she was in constant need of a competent seamstress who could cleverly alter the dozens of outfits she bought each season.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Till recently that person had been Rachel, whom Alice had discovered when Rachel had distributed brochures advertising her sewing skills through all her local letterboxes. Alice lived only a couple of streets away from Lettie’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the thirty-year age gap, the two women had got along well from the start. Alice’s natural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("joie de vivre")]), _vm._v(" had brought some brightness into Rachel’s dreary life. When her foster-mum passed away and her friends thought Rachel needed a job working outside of the home Alice had been generous enough to steer her into her present position, despite knowing this meant she had to find another person to alter her clothes. Fortunately, a salesgirl in one of the many boutiques Alice frequented had recommended an excellent alteration service in the city, run by two lovely Vietnamese ladies who were extremely efficient as well as inexpensive.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("After Rachel had gone to work for her son Alice had ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("rung her at the office a couple of times to see how she was doing, but this was the first time she’d made a personal appearance.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Alice!’ Rachel greeted happily. ‘What a lovely surprise. You’re looking extremely well. Blue always looks good on you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alice, who was as susceptible to a compliment as the next woman, beamed her pleasure. ‘Flatterer. Nothing looks all that good on this unfortunate figure of mine. But I do my best. And my, aren’t you looking a lot better these days? You’ve put on some weight. And you’ve changed your hair colour.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel’s hand went up to pat the offending hair. ‘Not for long. It goes back to brown tonight. I had it dyed for Isabel’s wedding on Saturday. You remember Isabel, don’t you? You met her at Lettie’s funeral.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, of course I remember her. Very blonde. Very beautiful.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s the one. She wanted my hair red for the day. Of course, it wasn’t done like this. It was down and curled. I also had more make-up on than a supermodel on a photo shoot.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll bet you looked gorgeous!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hardly. But I looked OK for the occasion. And for the photographs. I’m well aware this colour red doesn’t look any good on me normally.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But it might, you know, Rachel, if you wore some make-up. It’s just that against your pale skin it looks too bright. And without any colour in your face that black suit you’re wearing is too stark, by contrast. Now, if you were wearing blue,’ she added, her own blue eyes sparkling, ‘like the blue I’ve got on, and a spot of make-up, then that red hair just might be perfect.’")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel really wasn’t in the mood for another woman to start trying to make her over. Isabel had been bad enough on the weekend. On top of that, she was still upset over Justin ignoring her this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wouldn’t ignore her, however, if she started seriously tarting herself up. He’d think something was really up and then there would be hell to pay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Alice,’ she said, slightly wearily. ‘You were the one who told me about my predecessor, that flashy, flirtatious temp your son was so relieved to eject from his office. The reason Justin gave me this job is because he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("likes")]), _vm._v(" the way I look. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("likes")]), _vm._v(" me "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("au naturel")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alice rolled her eyes. In her opinion, no man liked women "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("au naturel")]), _vm._v(", even the ones who said they did. They all liked women to doll themselves up. You only had to watch men’s eyes when a glamour-puss walked into a restaurant, or a party. Justin was simply going through a phase, a post-Mandy phase.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trouble was, this phase was lasting far too long for her liking. It wasn’t natural. Or healthy, either, for her son’s mind or his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That boy doesn’t know "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _vm._v(" he likes any more,’ she grumbled. ‘That bitch of a wife of his certainly did a number on him. If ever I run into her again I’d like to…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whatever it was Alice was about to vow to do to her son’s ex-wife was cut dead when the door to Justin’s office was suddenly wrenched open, and the man of the moment appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mum! I thought I heard a familiar voice. What are you doing here? And what were you talking about just then? Not gossiping about me to Rachel, were you?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Alice’s cheeks flushed but she managed not to look ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("too guilty. ‘I never gossip,’ she threw at her son defiantly. ‘I only ever tell the truth.’")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Justin laughed. ‘In that case, why are you here? And no white lies, now. The truth, the whole truth and nothing but the truth.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alice shrugged. ‘I came to the city early to do some shopping, didn’t see a single thing I liked and decided on the spur of the moment to pop in and take you to lunch. Rachel too, if she’d like.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, no, no, I can’t,’ Rachel immediately protested. ‘I have some shopping that I simply have to do.’ Namely, some brown hair dye.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And neither can I,’ Justin informed his mother. ‘There was some unexpected bearish rumblings on the world stock markets last night and I have to have a report ready for the powers that be here before trading ceases today. So I’ll be working through lunch. I was going to get Rachel to pop out and bring me back some sandwiches.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Poor Rachel,’ Alice said. ‘I thought the days of secretaries doing that kind of menial and demeaning job were over. I dare say you have her bring you coffee twenty times a day as well. I know how much you like your coffee. What else? Does she collect your dry-cleaning too?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Justin looked taken aback. ‘Well, yes, she has collected my dry-cleaning. Once or twice.’ His eyes grew worried as they swung towards Rachel. ‘Do you object to doing that kind of job, Rachel? You’ve never said as much.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel sighed. Of course she didn’t object. If Alice thought those jobs were menial and demeaning, let her try changing urine-soaked sheets every morning.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, I don’t mind at all. Really, Alice,’ she insisted when Justin’s mother looked sceptical. ‘I don’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now it was Alice’s turn to sigh. ‘No, you wouldn’t. Just make sure you don’t take advantage of Rachel’s sweet nature,’ Alice warned her son.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel wished Alice would simply shut up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Justin’s eyes met hers again and she knew by their exasperated expression that he was thinking exactly the same thing. Rachel gave him a small smile of complicity, and his blue eyes twinkled back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would never take advantage of Rachel,’ he told his mother. ‘I value her far too much to do anything to risk losing the best PA a man could have.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel’s cheeks warmed at his flattering words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t realise at the time how ironic they were.")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad648f3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426883293_ch02.vue
// module id = 75
// module chunks = 0